import React, { useContext, useRef, useEffect } from 'react';
import Tracking from 'client/utils/tracking';
import { UserContext } from '../UserContext';

const UserTracker = () => {
  const { user } = useContext(UserContext);
  const prevUser = useRef<typeof user>(null);
  useEffect(() => {
    if (!user && prevUser.current) {
      // user logged out
      Tracking.reset();
    } else if (user && prevUser.current !== user) {
      // user changed or logged in
      Tracking.trackUser(user);
    }
    prevUser.current = user;
  }, [user]);
  return <></>;
};

export default UserTracker;
